import { ComponentPropsWithoutRef } from "react";
import styled from "styled-components";

// TEXT

// STYLES
export const Icon = styled.svg<{ $small?: boolean }>`
  height: ${({ $small }) => ($small ? "0.625rem" : "1rem")};
`;

// DATA

// TYPES
export interface Props extends ComponentPropsWithoutRef<"svg"> {
  small?: boolean;
}

// CONSTANTS

// FUNCTIONS

// ASSETS
